import type { ReactNode } from 'react';
import { Button } from '../Button';
import type { ButtonVariant } from '../Button';

export interface CTAProps {
  /** router path (e.g. /catalog) or absolute URL */
  to: string;
  children: ReactNode;
  variant?: ButtonVariant;
  /** optional supporting line above the button */
  note?: ReactNode;
}

/** A funnel call-to-action block. Posts should funnel into /catalog or /tools/*. */
export const CTA = ({ to, children, variant = 'primary', note }: CTAProps) => (
  <div className="my-7 rounded-10 border border-line bg-surface-2 px-5 py-5 text-center">
    {note ? <p className="mb-3 text-15 text-text-2">{note}</p> : null}
    <Button as="a" to={to} variant={variant}>
      {children}
    </Button>
  </div>
);
